import { grpc } from '@improbable-eng/grpc-web'
import { NodeHttpTransport } from '@improbable-eng/grpc-web-node-http-transport'
import { commonMetaData } from '~/store/_helpers/common-helper'

// initial state
export const state = () => ({})

// getters
export const getters = {}

// actions
export const actions = {
  async addRequestInformation({ commit, rootState }, data) {
    const [
      { AddRequestInformationRequest, AttachmentFiles },
      { RequestService }
    ] = await Promise.all([
      import('~/stub/apigateway/request/request_pb'),
      import('~/stub/apigateway/request/request_pb_service')
    ])
    const params = data.params
    const metadata = commonMetaData(rootState)
    const request = new AddRequestInformationRequest()

    request.setTitle(params.requestTitle)
    request.setContent(params.content)
    request.setMasterCategoryId(params.masterCategoryId)
    request.setPriceMin(params.priceMin)
    request.setPriceMax(params.priceMax)
    request.setWithholdingTaxFlag(params.withholdingTaxFlag)
    request.setExpireDate(params.expireDate)
    request.setDeliveryDateYear(params.deliveryDateYear)
    request.setDeliveryDateMonth(params.deliveryDateMonth)
    request.setDeliveryDateDay(params.deliveryDateDay)

    const attachmentFiles = []
    if (params.fileAttachment) {
      Object.values(params.fileAttachment).forEach(file => {
        const wrapper = new AttachmentFiles()
        wrapper.setFileName(file.fileName)
        wrapper.setFileUrl(file.fileUrl)
        wrapper.setMime(file.mime)
        wrapper.setSize(file.size)
        attachmentFiles.push(wrapper)
      })
    }
    request.setAttachmentFilesList(attachmentFiles)

    request.setGenreList(params.genre)
    request.setGenreOther(params.genreOther)
    request.setReferenceUrl(params.referenceUrl)
    request.setRequestSkill(params.requestSkill)
    request.setSpecialNoteList(params.specialNote)
    request.setCoverageList(params.coverage)
    request.setCoverageOther(params.coverageOther)
    request.setWorkCount(params.workCount)
    request.setWorkCountOther(params.workCountOther)
    request.setSize(params.size)
    request.setSizeOther(params.sizeOther)
    request.setDesiredColorImage(params.desiredColorImage)
    request.setDesiredColorImageOther(params.desiredColorImageOther)
    request.setDesiredDirectionDirectivity(params.desiredDirectionDirectivity)
    request.setDesiredDirectionColor(params.desiredDirectionColor)
    request.setDesiredDirectionDignity(params.desiredDirectionDignity)
    request.setDesiredDirectionGender(params.desiredDirectionGender)
    request.setFileTypeList(params.fileType)
    request.setPurposeTypeList(params.purposeType)
    request.setPurposeTypeOther(params.purposeTypeOther)
    request.setTargetAgeList(params.targetAge)
    request.setTargetAgeOther(params.targetAgeOther)
    request.setTargetSex(params.targetSex)
    request.setTargetSexOther(params.targetSexOther)
    request.setPreparedSomethingList(params.preparedSomething)
    request.setDevelopLanguageList(params.developLanguage)
    request.setDevelopLanguageOther(params.developLanguageOther)
    request.setWordCount(params.wordCount)
    request.setBusinessType(params.businessType)
    request.setCharacterCount(params.characterCount)
    request.setArticlePrice(params.articlePrice)
    request.setArticleCount(params.articleCount)
    request.setPageTypeList(params.pageType)
    request.setPreparedMaterialList(params.preparedMaterial)
    request.setPreparedMaterialOther(params.preparedMaterialOther)
    request.setTargetJob(params.targetJob)
    request.setLogoName(params.logoName)
    request.setLogoImageList(params.logoImage)
    request.setRegisterTrademark(params.registerTrademark)

    return await new Promise((resolve, reject) => {
      grpc.invoke(RequestService.AddRequestInformation, {
        request,
        metadata,
        host: process.env.config.grpcWebUrl,
        transport: NodeHttpTransport(),
        onMessage: message => {
          resolve(message.toObject())
        },
        onEnd: (grpcCode, message, trailers) => {
          if (grpcCode !== grpc.Code.OK) {
            reject({ grpcCode, message })
          }
        }
      })
    })
  }
}

// mutations
export const mutations = {}
